import { __assign } from "tslib";
import { createFilesApi } from './';
import { createHttpTestKit } from '../http/test-kit';
import { createFakePostResponder } from '../test-utils';
export var createFilesApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createFilesApi('', fakeHttp);
    var testKit = {
        whenUploadFile: function (dto) {
            return createFakePostResponder(fakeHttp, "/files")(dto);
        },
        whenUploadImageFromUrl: function (dto) {
            return createFakePostResponder(fakeHttp, "/files/remote")(dto);
        },
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map